// extracted by mini-css-extract-plugin
module.exports = {"selectWidth":"Reminders_selectWidth__1JPWd","selectedCheckBox":"Reminders_selectedCheckBox__1iIrG"};